import { render, staticRenderFns } from "./SeminarContent.vue?vue&type=template&id=a1a10764&scoped=true&"
import script from "./SeminarContent.vue?vue&type=script&lang=js&"
export * from "./SeminarContent.vue?vue&type=script&lang=js&"
import style0 from "./SeminarContent.vue?vue&type=style&index=0&id=a1a10764&prod&scoped=true&lang=css&"
import style1 from "./SeminarContent.vue?vue&type=style&index=1&id=a1a10764&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a10764",
  null
  
)

export default component.exports